// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__H2iv3","checkmark":"Checkbox_checkmark__VlWGT"};